import React, { Component } from 'react';
import {connect} from 'react-redux';
import viewHelper from '../../helpers/view';
import ProfileInfo from './profileInfo';
import Spinner from '../shared/spinner';
import { fetchAccount } from '../../actions/members';
import MemberInfo from '../shared/memberInfo';

class Account extends Component {

    componentDidMount() {
        let accountId = this.props.match.params.id;
        this.props.fetchAccount(accountId);
    }

    render () {
        const { member, account } = this.props;
        if (!account) {
            return ( <div> <Spinner /> </div> );
        } else {
            return (
                <div className="container content">
                    <MemberInfo title={`${viewHelper.getFullName(member)} - ${account.account_name}`} />
                    <div className="col-md-2 col-xs-12 col-lg-2 text-center">
                        <img alt="" src={member.profile_image_url} className="img-circle profile-image"/>
                    </div>
                    <div className="col-md-10 col-xs-12 col-lg-10 profile-info mb-15">
                        <div className="col-md-6 col-lg-6 col-xs-12 no-padding">
                            <ProfileInfo title='Account No'         info={account.id} />
                            <ProfileInfo title='Balance'            info={viewHelper.formatCurrency(account.balance)} />
                            <ProfileInfo title='Name On Account'    info={account.name_on_account} />
                            <ProfileInfo title='Status'             info={viewHelper.accountHasActiveStatus(account.account_active) ? 'Active' : 'Inactive'} />
                            <ProfileInfo title='Payment Method'     info={account.payment_method} />
                            <ProfileInfo title='Bank Name'          info={account.bank_name} />
                            <ProfileInfo title='ABA #'              info={account.aba_no} />
                            <ProfileInfo title='Checking Account #' info={account.checking_account_no} />
                            <ProfileInfo title='CC Account #'       info={account.credit_card_info} />
                        </div>
                        <div className="col-md-6 col-lg-6 col-xs-12 no-padding">
                            <ProfileInfo title='Card Type'         info={account.credit_card_type} />
                            <ProfileInfo title='Last 4 Digits'     info={account.last_4_digits} />
                            <ProfileInfo title='Exp Date'          info={account.credit_card_expire_date} />
                            <ProfileInfo title='Description'       info={account.description} />
                            <ProfileInfo title='Max Balance'       info={viewHelper.formatCurrency(account.maxbalance)} />
                            <ProfileInfo title='Max Days Old'      info={account.maxdaysold} />
                            <ProfileInfo title='Entered By'        info={account.entered_by} />
                            <ProfileInfo title='Entered On'        info={viewHelper.getFormattedDate(account.entered_on)} />
                            <ProfileInfo title='Allow POS Charges'  info={account.allow_pos_charges ? 'Yes' : 'No'} />
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    const { account } = state;
    return {
        account
    };
}

export default connect(mapStateToProps, { fetchAccount })(Account);
